<div class="header">
  <div class="title">
    {{ name }}
    <mat-icon *ngIf="hasError" fontSet="fa" fontIcon="fa-exclamation-circle"></mat-icon>
  </div>
  <div class="delete hidden md:block" (click)="removeAction.emit()" translate>
    PLAYLIST.CRITERIA.DELETE
  </div>
  <div class="delete block md:hidden px-1" (click)="removeAction.emit()">
    <mat-icon class="p-1" fontSet="fa" fontIcon="fa-times"></mat-icon>
  </div>
</div>
<div class="content"><ng-content></ng-content></div>
